import * as React from 'react';
import { cn } from '@companion-professional/webutils';

export const TableHeader = React.forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(
  ({ className, ...props }, ref) => <thead ref={ref} className={cn('[&_tr]:border-b [&_tr]:border-border', className)} {...props} />
);
TableHeader.displayName = 'TableHeader';
